// extracted by mini-css-extract-plugin
module.exports = {"tabs":"padViewPage_tabs__2n4Iw"};